// @NgModule decorator with its metadata
var Navbar_certModule = /** @class */ (function () {
    function Navbar_certModule() {
    }
    return Navbar_certModule;
}());
export { Navbar_certModule };
